import React, { useState, useEffect } from 'react';
import { collection, query, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import PostItem from './PostItem';
import ModernPostItem from './ModernPostItem';

interface PinnedPostsProps {
  onProfileClick: (userId: string) => void;
  variant?: 'classic' | 'modern';
  onPostDeleted?: (postId: string) => void;
}

export default function PinnedPosts({ onProfileClick, variant = 'classic', onPostDeleted }: PinnedPostsProps) {
  const [pinnedPosts, setPinnedPosts] = useState<any[]>([]);

  useEffect(() => {
    const fetchPinnedPosts = async () => {
      try {
        const pinnedRef = collection(db, 'pinnedPosts');
        const snapshot = await getDocs(pinnedRef);
        
        const posts = await Promise.all(
          snapshot.docs.map(async (pinnedDoc) => {
            const postId = pinnedDoc.data().postId;
            const postDoc = await getDoc(doc(db, 'posts', postId));
            
            if (postDoc.exists()) {
              return {
                id: postDoc.id,
                ...postDoc.data(),
                isPinned: true,
                inPinnedSection: true
              };
            }
            return null;
          })
        );
        
        setPinnedPosts(posts.filter(post => post !== null));
      } catch (error) {
        console.error('Error fetching pinned posts:', error);
      }
    };

    fetchPinnedPosts();
  }, []);

  if (pinnedPosts.length === 0) return null;

  return (
    <div className="mb-2">
      {pinnedPosts.map((post) => (
        variant === 'modern' ? (
          <ModernPostItem
            key={post.id}
            post={post}
            onProfileClick={onProfileClick}
            onPostDeleted={onPostDeleted || (() => {})}
          />
        ) : (
          <PostItem
            key={post.id}
            post={post}
            onProfileClick={onProfileClick}
            onPostDeleted={onPostDeleted || (() => {})}
          />
        )
      ))}
      <div className={`border-b ${variant === 'modern' ? 'border-gray-200 dark:border-navy-700' : 'border-orange-200'} my-2`}></div>
    </div>
  );
}
